import React, { useState, useEffect } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import HeaderApp from "../../components/HeaderApp";
import NoticiasEventosForm from "../../components/NoticiasEventosForm";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getNoticiaEvento } from "../../services/noticiasEventosService";

const getNoticiaEventoId = (item) =>
  item?.id ?? item?.Id ?? item?.idNoticiaEvento ?? item?.IdNoticiaEvento ?? item?.idNoticiasEventos ?? item?.idnoticiaseventos;

const NoticiasEventosFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isNew = !id || id === "nueva";
  const [noticiaEvento, setNoticiaEvento] = useState(null);
  const [loading, setLoading] = useState(!isNew);

  useEffect(() => {
    if (isNew) {
      setNoticiaEvento(null);
      setLoading(false);
      return;
    }
    const fromState = location.state?.noticiaEvento;
    if (fromState && String(getNoticiaEventoId(fromState)) === String(id)) {
      setNoticiaEvento(fromState);
      setLoading(false);
      return;
    }
    getNoticiaEvento(id)
      .then((data) => {
        const item = data?.data ?? data;
        setNoticiaEvento(item ?? null);
      })
      .catch(() => setNoticiaEvento(null))
      .finally(() => setLoading(false));
  }, [id, isNew, location.state]);

  const handleSuccess = () => {
    navigate("/NoticiasEventos");
  };

  if (!isNew && loading) {
    return (
      <>
        <HeaderApp />
        <Box component="main" sx={{ flex: 1, py: 4, px: 2, bgcolor: "background.default", minHeight: "calc(100vh - 64px)" }}>
          <Container maxWidth="md">
            <Typography color="text.secondary">Cargando...</Typography>
          </Container>
        </Box>
      </>
    );
  }

  return (
    <>
      <HeaderApp />
      <Box
        component="main"
        sx={{
          flex: 1,
          py: 4,
          px: 2,
          bgcolor: "background.default",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Container maxWidth="md">
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/NoticiasEventos")} sx={{ mb: 2 }}>
            Volver a noticias y eventos
          </Button>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
            {isNew ? "Agregar noticia o evento" : "Editar noticia o evento"}
          </Typography>
          <NoticiasEventosForm noticiaEventoData={isNew ? null : noticiaEvento} onSuccess={handleSuccess} />
        </Container>
      </Box>
    </>
  );
};

export default NoticiasEventosFormPage;
